export const buildOrderedIds = <T>(
  items: T[],
  orderIds: number[] | undefined,
  getId: (item: T) => number | undefined | null
): number[] => {
  const itemIds = items
    .map((item) => getId(item))
    .filter((id): id is number => typeof id === "number");

  const seen = new Set<number>();
  const ordered: number[] = [];

  (orderIds || []).forEach((id) => {
    if (itemIds.includes(id) && !seen.has(id)) {
      ordered.push(id);
      seen.add(id);
    }
  });

  itemIds.forEach((id) => {
    if (!seen.has(id)) {
      ordered.push(id);
      seen.add(id);
    }
  });

  return ordered;
};

export const sortByOrder = <T>(
  items: T[],
  orderIds: number[] | undefined,
  getId: (item: T) => number | undefined | null
): T[] => {
  const orderIndex = new Map<number, number>();
  (orderIds || []).forEach((id, index) => {
    orderIndex.set(id, index);
  });

  return [...items].sort((a, b) => {
    const aId = getId(a);
    const bId = getId(b);
    const aPos =
      typeof aId === "number" && orderIndex.has(aId)
        ? orderIndex.get(aId)!
        : Number.MAX_SAFE_INTEGER;
    const bPos =
      typeof bId === "number" && orderIndex.has(bId)
        ? orderIndex.get(bId)!
        : Number.MAX_SAFE_INTEGER;
    if (aPos === bPos) {
      return 0;
    }
    return aPos - bPos;
  });
};
